import { Tooltip as ReactTooltip } from 'react-tooltip';
import styled from 'styled-components';

export const ChartTooltip = styled(ReactTooltip)`
    &.react-tooltip {
        background-color: #C4C4C4 !important;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
        color: #000;
        max-width: 300px;
        opacity: 1 !important;
        text-align: start;
    }

    &.react-tooltip .react-tooltip-arrow {
        background-color: #C4C4C4;
    }
`;
